import { __assign } from "tslib";
import React from 'react';
import { Badge, Text } from '@keen.io/ui-core';
import { Container, TextContainer, Label, TextContent } from './header.styles';
export var Header = function (_a) {
    var label = _a.label, percentageValue = _a.percentageValue, _b = _a.flipBadge, flipBadge = _b === void 0 ? false : _b, value = _a.value, theme = _a.theme;
    var header = theme.funnel.header;
    return (React.createElement(Container, { useColumns: flipBadge },
        React.createElement(TextContent, null,
            header.value.enabled && (React.createElement(TextContainer, null,
                React.createElement(Text, __assign({}, header.value.typography), value))),
            React.createElement(Label, { title: label },
                React.createElement(Text, __assign({ truncate: true }, header.title.typography), label))),
        header.badge.enabled && (React.createElement("div", null,
            React.createElement(Badge, { variant: header.badge.variant },
                React.createElement(Text, __assign({}, header.badge.typography),
                    percentageValue.toFixed(0),
                    "%"))))));
};
export default Header;
